


<template>
    <div style="width:100%">
      <button class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center" @click="$emit('print')" >
        <font-awesome-icon :icon="['fas', 'print']" />
        <span>{{ $t("Stampa Esami") }}</span>
      </button>
    </div>
</template>